import {
    SELECT_STUDENT,
    FETCH_STUDENT_ENROLLMENT_INFO,
    FETCH_ALL_STUDENTS_ENROLLMENT_INFO,
    CLEAR_STUDENT_SUMMARY_DATA,
    SELECT_GRADE_YEAR,
} from '../../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../../actionCreators';
import config from '../../../configs/master';

export const selectStudent = selectedStudentId => ({
    type: SELECT_STUDENT,
    selectedStudentId,
});

export const clearStudentSummaryData = () => ({
    type: CLEAR_STUDENT_SUMMARY_DATA,
});

export const selectGradeYear = (selectedGradeYear, studentId, tabName) => ({
    type: SELECT_GRADE_YEAR,
    selectedGradeYear,
    studentId,
    tabName,
});

export const sharedFetchStudentEnrollmentInfo =
    (studentId, client) => async (dispatch, getState) => {
        const { selectors } = config.root;
        const { isDemoClass } = selectors.getCommonData(getState());
        const additionalApiParams = {
            apiParams: [[studentId], isDemoClass],
        };

        await apiActionCreator(
            dispatch,
            FETCH_STUDENT_ENROLLMENT_INFO,
            client.getStudentsEnrollmentInfo,
            additionalApiParams,
        );
    };

export const sharedFetchAllStudentsEnrollmentInfo =
    (studentIds, client, successfulCallback = () => {}) =>
    async (dispatch, getState) => {
        const { selectors } = config.root;
        const { isDemoClass } = selectors.getCommonData(getState());
        const additionalApiParams = {
            afterApiCallCalback: () => {
                successfulCallback();
            },
            apiParams: [studentIds, isDemoClass],
        };
        await apiActionCreator(
            dispatch,
            FETCH_ALL_STUDENTS_ENROLLMENT_INFO,
            client.getStudentsEnrollmentInfo,
            additionalApiParams,
        );
    };
